import { P2GText, P2GLink } from '@parcel2go/core-ui';
import { PaymentOptionApiModel, PaymentOptionOptionApiModel } from '~/lib/api/smartsend/types';
import ProviderName from '../../../../lib/helpers/ProviderName';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { EventSections } from '../../../../lib/events/EventLogger';
import useGoto from '~/hooks/use-goto';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { SmartSendProvider } from '~/lib/consts/providers';
import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

interface props {
  paymentType: PaymentOptionApiModel;
  option: PaymentOptionOptionApiModel;
  close: () => void;
}

export default function PaymentLabel(props: props) {
  const { track } = useSmartSendAnalytics();
  const { goTo } = useGoto();
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  switch (props.paymentType.Type) {
    case 'CourierAccount':
    case 'Invoiced':
      return <P2GText variant="body2">{ProviderName(props.paymentType.Provider)}</P2GText>;
    case 'TopUp':
      return props.paymentType.Provider === SmartSendProvider ? (
        <P2GText variant="body2">
          {t('TOPUP_PREPAY_BALANCE_PAYMENT_LABEL', {
            defaultValue: 'PrePay (Balance: {{balance}})',
            balance: toDisplayCurrency(props.paymentType.CurrencyCode, props.paymentType.Balance)
          })}
          {SettingsCache.settings.Features.includes('PrePay') && (
            <P2GLink
              ml={1}
              onClick={() => {
                track({
                  type: 'topup_prepay_click',
                  payload: {
                    ...GenerateBaseAnalyticsPayload([EventSections.SmartSend, EventSections.Book])
                  }
                });
                goTo(RoutingConstants.Billing_PrePay);
              }}
            >
              {t('TOP_UP_HERE_PAYMENT_LABEL', { defaultValue: 'Top up here' })}
            </P2GLink>
          )}
        </P2GText>
      ) : (
        <P2GText variant="body2">
          {t('TOPUP_PREPAY_BALANCE_PAYMENT_LABEL', {
            defaultValue: 'PrePay (Balance: {{balance}})',
            balance: toDisplayCurrency(props.paymentType.CurrencyCode, props.paymentType.Balance)
          })}
        </P2GText>
      );
    case 'SavedPayment':
      return (
        <P2GText variant="body2">
          {t('STORED_CARD_PAYMENT_LABEL', {
            defaultValue: 'Stored Card {{display}}',
            display: props.option?.Display || props.paymentType.Options[0]?.Display
          })}
        </P2GText>
      );
    case 'External':
      return (
        <P2GText variant="body2">{t('PAYMENT_BY_CARD_PAYMENT_LABEL', { defaultValue: 'Payment By Card' })}</P2GText>
      );
    default:
      return <P2GText variant="body2">{props.paymentType.Type}</P2GText>;
  }
}
